<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="c_group">
        <query-form
          class="content_block"
          label-width="90px"
          size="small"
          label-position="right"
          @search="handleFilterList"
          @reset="handleReset"
          :keepOpenedRow="2">
          <el-form-item label="订单编号">
            <el-input
              v-model.trim="advancedForm.code"
              clearable
              placeholder="请输入订单编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品信息">
            <el-input
              v-model.trim="advancedForm.goodsNameOrSkuCodeOrOutSkuCode"
              clearable
              placeholder="请输入商品名称/编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="收货人">
            <el-input
              v-model.trim="advancedForm.receiverName"
              clearable
              placeholder="请输入收货人"
            ></el-input>
          </el-form-item>
          <el-form-item label="收货人手机">
            <el-input
              v-model.trim="advancedForm.receiverPhone"
              clearable
              placeholder="请输入收货人手机"
            ></el-input>
          </el-form-item>
          <el-form-item label="收货地址">
            <el-input
              v-model.trim="advancedForm.fullReceiverDetailAddress"
              clearable
              placeholder="请输入收货地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否医疗件">
            <el-select v-model.trim="advancedForm.medicalFlag" clearable placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="医疗件" :value="true"></el-option>
              <el-option label="非医疗件" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </query-form>
      </div>
      <div class="table-wrapper">
        <xz-table
          ref="xzTable"
          :toolsAttrs="toolsAttrs"
          :columns="columns"
          :data="dataList"
          :scroll="{ x: '100%', y: scrollHeight }"
          rowKey="id"
          @refresh="handleReset">
          <template #buttons>
            <span style="margin-right: 10px;">共 {{ pageSelectCount }} 条数据</span>
            <el-popover placement="right-start" width="360" trigger="manual" v-model="isShowBatch">
              <div class="headerTitle">
                <span>批量录入</span>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content" class="tooltipContent" style="padding: 12px">
                    <h4 style="margin-bottom: 10px">操作说明</h4>
                    <ol>
                      <li>
                        单项输入框 录入修改信息，点击录入按钮，修改表单内对应数据。
                        <br />
                        单项输入框未录入信息，不修改对应数据；
                      </li>
                      <li>多选按钮取消勾选，当前项不可编辑</li>
                      <li>多选按钮选中项，点击清空按钮，清空选中信息，未选中信息不影响。</li>
                    </ol>
                  </div>
                  <i class="el-icon-question" type="primary"></i>
                </el-tooltip>
              </div>
              <div v-if="selectedKeys.length && isShowBatch" class="content">
                <el-form :model="JZChoice2" ref="JZChoice2" class="JZCatrgoryForm content_block" :inline="true">
                  <el-form-item prop="logisticsCompany" label-width="0" label="">
                    <el-checkbox v-model="checkedChoices2.logisticsCompany">物流公司：</el-checkbox>
                    <el-select
                      v-model.trim="JZChoice2.logisticsCompany"
                      clearable
                      filterable
                      :popper-append-to-body="false"
                      placeholder="请选择"
                      value-key="id"
                      remote
                      reserve-keyword
                      :remote-method="logisticsList"
                      style="width: 200px"
                    >
                      <el-option v-for="item in logisticsOptions" :key="item.id" :label="item.name" :value="item">
                        {{ item.name }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="code" label-width="0" label="">
                    <el-checkbox v-model="checkedChoices2.logisticsCode">物流单号：</el-checkbox>
                    <el-input
                      placeholder="请输入"
                      style="width: 200px"
                      v-model.trim="JZChoice2.logisticsCode"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="dialog-footer" style="text-align: right; display: inline-block; width: 100%">
                <el-button @click="isShowBatch = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleEmpty2" size="mini" plain>清 空</el-button>
                <el-button type="primary" @click="handleEnsure2" size="mini">确 定</el-button>
              </div>
              <el-button
                icon="el-icon-plus"
                size="mini"
                type="primary"
                :disabled="!selectedKeys.length"
                slot="reference"
                @click="handleBatchLogistics"
                style="margin-right: 10px;"
              >
                批量录入
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </el-popover>
            <a-checkbox @change="handleMergeButton">
              仅展示可合并发货订单
            </a-checkbox>
          </template>
          <template #custom>
            <div class="right-box">
              合并发货
              <el-tooltip class="item" effect="dark" content="合并发货自动将收货人/手机号/地址相同的订单合并" placement="top">
                <i class="el-icon-warning-outline" style="font-size: 14px;margin-left: 5px;"></i>
              </el-tooltip>
              <a-switch v-model="merge" @change="handleMergeChange" style="padding: 10px 0; height: auto;" />
            </div>
          </template>
          <template slot="imageList" slot-scope="image">
            <span v-if="image && image.split(',').length > 0">
              <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
              </span>
              <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
            </span>
            <span v-else>暂无图片</span>
          </template>
          <!-- 发货数量 -->
          <template slot="unDeliveredQuantity" slot-scope="unDeliveredQuantity, row, index">
            <template v-if="row.dockingSystem === 'XIAOZI_ERP'">
              <template v-if="row.directFlag === 1">
                <div @click="handleDeliveryGoods(row, index)" class="num" style="text-align: center;">{{ row.quantity }}</div>
                <div v-if="row.warn" class="warn">{{ row.warnMsg }}</div>
              </template>
              <template v-if="row.directFlag === 2">
                <el-input-number
                  v-model="row.quantity"
                  :min="1"
                  :max="row.unDeliveredQuantity"
                  :step="1"
                  style="width: 125px;"
                />
              </template>
            </template>
            <template v-else>
              <div @click="handleDeliveryGoods(row, index)" class="num" style="text-align: center;">{{ row.quantity }}</div>
              <div v-if="row.warn" class="warn">{{ row.warnMsg }}</div>
            </template>
          </template>
          <!-- 物流公司 -->
          <template slot="logisticsCompanyName" slot-scope="logisticsCompanyName, row, index">
            <template v-if="row.dockingSystem === 'XIAOZI_ERP'">
              <a-select
                :value="row.logisticsCompanyId"
                show-search
                placeholder="请输入"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="logisticsList1"
                @change="handleChangeLogistics($event, row, index)"
                style="width: 100%;"
              >
                <a-select-option v-for="item in logisticsOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </template>
            <template v-else>
              <a-select
                :value="row.logisticsCompanyId"
                show-search
                placeholder="请输入"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="logisticsList2"
                @change="handleChangeLogistics($event, row, index)"
                style="width: 100%;"
              >
                <a-select-option v-for="item in logisticsOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </template>
          </template>
          <!-- 物流单号 -->
          <template slot="logisticsCode" slot-scope="_, row">
            <el-input v-model="row.logisticsCode" placeholder="请输入"></el-input>
          </template>
        </xz-table>
      </div>
    </div>
    <BottomPanel v-if="$withPermission('gongxutong:sale:order:delivery')">
      <slot>
        <el-button @click="cancel" size="small">取消</el-button>
        <el-button :disabled="!dataList.length" type="primary" size="small" @click="submit()">确认发货</el-button>
      </slot>
    </BottomPanel>

    <el-dialog title="发货商品" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="80%">
      <div class="top" style="margin-bottom: 10px">
        <el-popover placement="right-start" width="360" trigger="manual" v-model="isShow">
          <div class="headerTitle">
            <span>批量录入</span>
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" class="tooltipContent" style="padding: 12px">
                <h4 style="margin-bottom: 10px">操作说明</h4>
                <ol>
                  <li>
                    单项输入框 录入修改信息，点击录入按钮，修改表单内对应数据。
                    <br />
                    单项输入框未录入信息，不修改对应数据；
                  </li>
                  <li>多选按钮取消勾选，当前项不可编辑</li>
                  <li>多选按钮选中项，点击清空按钮，清空选中信息，未选中信息不影响。</li>
                </ol>
              </div>
              <i class="el-icon-question" type="primary"></i>
            </el-tooltip>
          </div>
          <div class="content">
            <el-form :model="JZChoice" ref="JZChoice" class="JZCatrgoryForm content_block" :inline="true">
              <el-checkbox-group v-model="checkedChoices">
                <el-checkbox label="productionDate">
                  <el-form-item prop="productionDate" label-width="90px" label="生产日期：">
                    <el-date-picker
                      placeholder="请选择生产日期"
                      :disabled="!checkedChoices.includes('productionDate')"
                      type="date"
                      :picker-options="pickerOptions"
                      style="width: 200px"
                      value-format="yyyy-MM-dd"
                      v-model.trim="JZChoice.productionDate"
                    ></el-date-picker>
                  </el-form-item>
                </el-checkbox>
                <el-checkbox label="expiryDate">
                  <el-form-item prop="expiryDate" label-width="90px" label="失效日期：">
                    <el-date-picker
                      placeholder="请选择失效日期"
                      :disabled="!checkedChoices.includes('expiryDate')"
                      type="date"
                      :picker-options="pickerOptions1"
                      style="width: 200px"
                      value-format="yyyy-MM-dd"
                      v-model.trim="JZChoice.expiryDate"
                    ></el-date-picker>
                  </el-form-item>
                </el-checkbox>
                <el-checkbox label="productionBatchNumber" v-if="isMedichair && dockingSystem === 'XIAOZI_ERP'">
                  <el-form-item prop="productionBatchNumber" label-width="90px" label="生产批次号：">
                    <el-input
                      placeholder="请输入生产批次号"
                      :disabled="!checkedChoices.includes('productionBatchNumber')"
                      style="width: 200px"
                      v-model.trim="JZChoice.productionBatchNumber"
                    ></el-input>
                  </el-form-item>
                </el-checkbox>
                <el-checkbox label="productionSerialNumber" v-if="isMedichair && dockingSystem === 'XIAOZI_ERP'">
                  <el-form-item prop="productionSerialNumber" label-width="90px" label="生产序列号：">
                    <el-input
                      placeholder="请输入生产序列号"
                      :disabled="!checkedChoices.includes('productionSerialNumber')"
                      style="width: 200px"
                      v-model.trim="JZChoice.productionSerialNumber"
                    ></el-input>
                  </el-form-item>
                </el-checkbox>
              </el-checkbox-group>
            </el-form>
          </div>
          <div class="dialog-footer" style="text-align: right; display: inline-block; width: 100%">
            <el-button @click="isShow = false" size="mini">取 消</el-button>
            <el-button type="primary" @click="handleEmpty" size="mini" plain>清 空</el-button>
            <el-button type="primary" @click="handleEnsure" size="mini">确 定</el-button>
          </div>
          <el-button
            icon="el-icon-plus"
            size="mini"
            type="primary"
            :disabled="!checkedLists.length"
            slot="reference"
            @click="isShow = !isShow"
          >
            批量录入
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-popover>
        <el-button
          icon="el-icon-close"
          size="mini"
          type="primary"
          color="#FF5500"
          :disabled="!checkedLists.length"
          style="margin-left: 10px"
          @click="batchEmptying"
        >
          批量清空
        </el-button>
        <el-button
          icon="el-icon-delete"
          size="mini"
          type="primary"
          :disabled="!checkedLists.length"
          @click="batchDelete"
        >
          批量删除
        </el-button>
      </div>
      <vxe-grid
        v-if="visible"
        class="content-block"
        resizable
        autoResize
        ref="xTable"
        border="inner"
        size="small"
        max-height="500"
        row-id="rowId"
        :data="goodsSerialList"
        showOverflow
        highlight-current-row
        highlight-hover-row
        highlight-current-column
        highlight-hover-column
        align="center"
        @checkbox-change="handleCheckboxChanged"
        @checkbox-all="handleCheckboxAllChecked"
        :scroll-y="{ enabled: true, mode: 'default', gt: 30 }"
        :columns="childColumn"
        style="width: 100%"
        :edit-config="{ mode: 'cell', showIcon: false }"
        :edit-rules="setRules()">
        <template #headerProductionDate>
          <div><span style="color: red;">*</span>生产日期</div>
        </template>
        <template #productionDate="{ row }">
          <el-date-picker
            placeholder="请选择日期"
            type="date"
            :picker-options="pickerOptions"
            style="width: 140px"
            value-format="yyyy-MM-dd"
            v-model.trim="row.productionDate">
          </el-date-picker>
        </template>
        <template #headerExpiryDate>
          <div><span style="color: red;">*</span> 失效日期</div>
        </template>
        <template #expiryDate="{ row }">
          <el-date-picker
            placeholder="请选择日期"
            type="date"
            style="width: 140px"
            value-format="yyyy-MM-dd"
            v-model.trim="row.expiryDate">
          </el-date-picker>
        </template>
        <template #headerBatchNumber>
          <div>生产批次号</div>
        </template>
        <template #productionBatchNumber="{ row }">
          <el-input
            placeholder="请输入生产批次号"
            v-model.trim="row.productionBatchNumber"
          ></el-input>
        </template>
        <template #headerSerialNumber>
          <div>生产序列号</div>
        </template>
        <template #productionSerialNumber="{ row }">
          <el-input
            placeholder="请输入生产序列号"
            v-model.trim="row.productionSerialNumber"
          ></el-input>
        </template>
        <template #imageList="{ row }">
          <span v-if="row.image && row.image.split(',').length > 0">
            <span v-for="(img, i) in row.image.split(',')" :key="'img-'+i">
              <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="row.image.split(',')" />
            </span>
            <span v-if="row.image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
          </span>
          <span v-else>暂无图片</span>
        </template>
      </vxe-grid>
      <el-row style="margin-top: 12px; text-align: right">
        <el-button size="mini" @click="operate('cancel')">取消</el-button>
        <el-button type="primary" size="mini" @click="operate('save')">保存</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import _ from 'lodash';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import setTableCols from './configs';
import { getSupplierPage, logisticsCompany, batchAdd } from '@/api/pickUpOrders';
import { setDeliveryGoodsColumn, setDeliveryGoodsColumn2 } from '@/views/pickUpOrders/configs/shipConfig';

export default {
  name: 'OrderShipFill',
  components: {
    xzTable,
  },
  computed: {
    toolsAttrs () {
      return {
        custom: true,
      };
    },
    indeterminate () {
      return this.pageSelectedLists.length && this.pageSelectedLists.length !== this.pageSelectCount || false;
    },
    checkedAll () {
      return this.pageSelectCount === this.pageSelectedLists.length || false;
    },
    allSelectedIdLists () {
      return this.checkedLists.map((item, index) => index);
    },
  },
  data () {
    return {
      scrollHeight: 'calc(100vh - 410px)',
      advancedForm: {
        code: '',
        goodsNameOrSkuCodeOrOutSkuCode: '',
        receiverName: '',
        receiverPhone: '',
        medicalFlag: '',
        fullReceiverDetailAddress: '',
      },
      localSelectedAllKeys: [], // 原始选中的所有订单的id
      localSelectedAllLists: [], // 原始选中的所有订单
      filterLists: [], // 过滤后的订单
      columns: [
        {
          // title: '全选',
          dataIndex: 'selection',
          key: 'selection',
          fixed: 'left',
          width: 60,
          title: () => {
            const h = this.$createElement;
            return h('a-checkbox', {
              attrs: {
                indeterminate: this.indeterminate,
                checked: this.checkedAll,
              },
              on: {
                change: (e) => {
                  this.handleSelectAll(e.target.checked);
                },
              },
            });
          },
          customRender: (text, row) => {
            const h = this.$createElement;
            const obj = {
              children: h('a-checkbox', {
                attrs: {
                  checked: row.checked,
                },
                on: {
                  change: (e) => {
                    this.handleSelect(row, e.target.checked);
                  },
                },
              }),
              attrs: row.merge ? { rowSpan: row.mergeSpan || 0 } : (row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 }),
            };
            return obj;
          },
        },
        {
          title: '收货信息',
          dataIndex: 'fullReceiverDetailAddress',
          key: 'fullReceiverDetailAddress',
          width: 260,
          ellipsis: true,
          customRender: (text, row) => {
            const h = this.$createElement;
            const obj = {
              children: row.merge && row.mergeSpan > 1 && row.codes?.length > 1 ? h('div', {}, [
                h('div', {
                  attrs: {
                    title: row.fullReceiverDetailAddress,
                  },
                }, row.fullReceiverDetailAddress),
                h('el-button', {
                  attrs: {
                    type: 'text',
                    size: 'small',
                  },
                  on: {
                    click: () => this.handleCancelMerge(row),
                  },
                }, '取消合并'),
              ]) : (text || '--'),
              attrs: row.merge ? { rowSpan: row.mergeSpan || 0 } : (row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 }),
            };
            return obj;
          },
        },
        ...setTableCols('fill'),
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
          customRender: (text, row) => {
            const obj = {
              children: <a style="margin-left: 8px" onClick={this.handleCancelShip.bind(this, row)}>取消发货</a>,
              attrs: row.merge ? { rowSpan: row.mergeSpan || 0 } : (row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 }),
            };
            return obj;
          },
        },
      ],
      dataList: [],
      selectedKeys: [],
      selectedLists: [],
      pageSelectCount: 0,
      pageSelectedLists: [],

      merge: localStorage.getItem('mergePick') === 'true' || false,
      mergeButton: false,
      logisticsOptions: [],

      isShowBatch: false,
      JZChoice2: {
        logisticsCode: '',
        logisticsCompany: {},
      },
      checkedChoices2: {
        logisticsCompany: true,
        logisticsCode: true,
      },
      dockingSystemArray: [],

      // 发货商品信息
      isShow: false,
      dockingSystem: '',
      isDirect: 1,
      visible: false,
      childColumn: [],
      goodsSerialList: [],
      checkedLists: [],
      currentIndex: 0,
      checkedChoices: ['productionDate', 'expiryDate', 'productionBatchNumber', 'productionSerialNumber'],
      JZChoice: {
        productionBatchNumber: '',
        productionSerialNumber: '',
        expiryDate: '',
        productionDate: '',
      },
      isMedichair: true,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() || time.getTime() > new Date(this.productionDate);
        },
      },
    };
  },
  mounted () {
    this.localSelectedAllKeys = JSON.parse(localStorage.getItem('selectedAllKeys')) || [];
    this.localSelectedAllLists = (JSON.parse(localStorage.getItem('selectedAllLists')) || []).map(row => {
      row.fullReceiverDetailAddress = `${row.receiverName || ''}-${row.receiverPhone || ''}-${row.receiverProvinceName || ''}${row.receiverCityName || ''}${row.receiverAreaName || ''}${row.receiverDetailAddress || ''}` || '--';
      return row;
    });
    this.getList('init');
  },
  methods: {
    handleBatchLogistics () {
      this.dockingSystemArray = [...new Set(this.dockingSystemArray)];
      if (this.dockingSystemArray.length > 1) {
        this.$message({
          message: '请选择相同的对接系统订单',
          type: 'warning',
        });
        return;
      }
      this.dockingSystem = this.dockingSystemArray[0];
      this.isShowBatch = !this.isShowBatch;
    },
    handleCheckboxChanged ({ checked, row }) {
      this.$emit('select', { row, checked });
      this.handleSelectionChange();
    },
    handleCheckboxAllChecked ({ records, checked }) {
      this.$emit('select-all', { selections: records, checked });
      this.handleSelectionChange();
    },
    handleSelectionChange () {
      let selections = this.$refs.xTable.getCheckboxRecords();
      this.checkedLists = selections;
    },
    validateProductionDate ({ cellValue: value, rowIndex }) {
      if (value && this.goodsSerialList[rowIndex].expiryDate) {
        let s = new Date(value).getTime();
        let e = new Date(this.goodsSerialList[rowIndex].expiryDate).getTime();

        if (s >= e) {
          return new Error('生产日期必须小于失效日期');
        }
      }
    },
    validateExpiryDate ({ cellValue: value, rowIndex }) {
      if (this.goodsSerialList[rowIndex].productionDate && value) {
        let s = new Date(this.goodsSerialList[rowIndex].productionDate).getTime();
        let e = new Date(value).getTime();

        if (s >= e) {
          return new Error('失效日期必须大于生产日期');
        }
      }
    },
    validateNumber ({ rowIndex }) {
      if (
        this.isMedichair
        && this.dockingSystem === 'XIAOZI_ERP'
        && !this.goodsSerialList[rowIndex].productionBatchNumber
        && !this.goodsSerialList[rowIndex].productionSerialNumber
      ) {
        return new Error('请填写生产批次号或者生产序列号');
      }
    },
    setRules () {
      const rules = {
        productionDate: [
          { required: true, message: '请选择生产日期' },
          { validator: this.validateProductionDate, trigger: blur },
        ],
        expiryDate: [
          { required: true, message: '请选择失效日期' },
          { validator: this.validateExpiryDate, trigger: blur },
        ],
        productionBatchNumber: [{ validator: this.validateNumber, trigger: blur }],
        productionSerialNumber: [{ validator: this.validateNumber, trigger: blur }],
      };

      if (this.isDirect === 2) {
        rules.quantity = [{ required: true, message: '请输入本次发货数量' }];
      }

      return rules;
    },
    setDate (type) {
      if (type === 'produce') {
        return Moment().add(-30, 'day').format('YYYY-MM-DD');
      } else {
        return Moment().add(2, 'year').format('YYYY-MM-DD');
      }
    },
    handleMergeButton (val) {
      this.mergeButton = val.target.checked;
      this.dealMerge();
    },
    handleMergeChange (val) {
      this.merge = val;
      localStorage.setItem('mergePick', val);
      this.dealMerge();
    },
    dealMerge () {
      // 从this.localSelectedAllLists中搜索符合advancedForm中条件的项
      let baseFilterLists = [];
      baseFilterLists = this.localSelectedAllLists.filter(item => {
        // 1. 检查主对象的非 goodsNameOrSkuCodeOrOutSkuCode 条件
        const matchCode = this.advancedForm.code === '' || (item.code && item.code.includes(this.advancedForm.code));
        const matchReceiverName = this.advancedForm.receiverName === '' || (item.receiverName && item.receiverName.includes(this.advancedForm.receiverName));
        const matchReceiverPhone = this.advancedForm.receiverPhone === '' || (item.receiverPhone && item.receiverPhone.includes(this.advancedForm.receiverPhone));
        const matchAddress = this.advancedForm.fullReceiverDetailAddress === '' || (item.fullReceiverDetailAddress && item.fullReceiverDetailAddress.includes(this.advancedForm.fullReceiverDetailAddress));

        // 2. 检查 goodsNameOrSkuCodeOrOutSkuCode 条件（包括 orderGoodsList）
        const searchValue = this.advancedForm.goodsNameOrSkuCodeOrOutSkuCode;

        let matchGoodsCondition = true; // 默认 true，因为空字符串也匹配

        if (searchValue && searchValue !== '') {
          // 检查主对象
          const matchMain = (item.goodsName && item.goodsName.includes(searchValue))
            || (item.skuCode && item.skuCode.includes(searchValue))
            || (item.outSkuCode && item.outSkuCode.includes(searchValue));

          // 如果主对象不匹配，检查 orderGoodsList
          if (!matchMain && item.orderGoodsList && item.orderGoodsList.length > 0) {
            const matchInOrderGoods = item.orderGoodsList.some(goods => {
              return (goods.goodsName && goods.goodsName.includes(searchValue))
                || (goods.skuCode && goods.skuCode.includes(searchValue))
                || (goods.outSkuCode && goods.outSkuCode.includes(searchValue));
            });
            matchGoodsCondition = matchInOrderGoods;
          } else {
            matchGoodsCondition = matchMain;
          }
        }

        let matchMedicalFlag = true;
        if (this.advancedForm.medicalFlag !== '') {
          if (item.orderGoodsList && item.orderGoodsList.length > 0) {
            const matchInOrderGoods = item.orderGoodsList.some(goods => {
              return goods.medicalFlag === this.advancedForm.medicalFlag;
            });
            matchMedicalFlag = matchInOrderGoods;
          }
        }

        // 3. 所有条件都必须满足
        return matchCode && matchGoodsCondition && matchReceiverName && matchReceiverPhone && matchMedicalFlag && matchAddress;
      });
      if (this.mergeButton) {
        this.filterLists = [];
        // 找出 baseFilterLists 中 有多个fullReceiverDetailAddress 相同的项
        let addressCount = {};
        baseFilterLists.forEach(item => {
          addressCount[item.fullReceiverDetailAddress] = (addressCount[item.fullReceiverDetailAddress] || 0) + 1;
        });
        baseFilterLists.forEach(item => {
          if (addressCount[item.fullReceiverDetailAddress] > 1) {
            this.filterLists.push(item);
          }
        });
      } else {
        this.filterLists = baseFilterLists;
      }
      this.getList('filter');
    },
    handleSelectAll (isChecked) {
      let rowSpan = this.merge ? 'mergeSpan' : 'rowSpan';
      this.dataList.map(item => {
        if (item.merge && item.codes?.length > 0) {
          item.checked = isChecked;
        } else if (!item.merge && item.rowSpan > 0) {
          item.checked = isChecked;
        }
      });
      if (isChecked) {
        const pageSelectedKeys = this.dataList.filter(item => item[rowSpan]).filter(item => item.checked).map(item => item.id) || [];
        this.selectedKeys = this.selectedKeys.concat(pageSelectedKeys);
      } else {
        const notSelectedKeys = this.dataList.filter(item => item[rowSpan]).map(item => item.id);
        this.selectedKeys = this.selectedKeys.filter(item => !notSelectedKeys.includes(item));
      }
      this.getSelected();
    },
    handleSelect (row, isChecked) {
      if (isChecked) {
        this.selectedKeys.push(row.id);
      } else {
        const index = this.selectedKeys.indexOf(row.id);
        if (index !== -1) {
          this.selectedKeys.splice(index, 1);
        }
      }
      // 找到id对应的第一行
      const i = this.dataList.findIndex(item => item.id === row.id);
      if (i !== -1) {
        this.$set(this.dataList[i], 'checked', isChecked);
      }
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
      this.getSelected();
    },
    getSelected () {
      this.selectedKeys = [...new Set(this.selectedKeys)];
      this.pageSelectedLists = this.dataList.filter(item => item.checked) || [];

      this.selectedLists = this.selectedLists.concat(this.pageSelectedLists);
      this.selectedLists = this.selectedLists.filter(item => this.selectedKeys.indexOf(item.id) !== -1);
      this.dockingSystemArray = this.selectedLists.map(item => item.dockingSystem);
      // 数组对象去重
      let map = new Map();
      for (let item of this.selectedLists) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      }
      this.selectedLists = [...map.values()];
    },
    batchEmptying () {
      // 将选中项数据数值初始化
      this.$confirmAlert(`确认将选中的${this.checkedLists.length}条商品信息清空吗?`, '确认清空').then(() => {
        let currentLists = this.goodsSerialList.map((item, index) => {
          if (this.allSelectedIdLists.includes(index)) {
            item = {
              ...item,
              productionBatchNumber: '',
              productionSerialNumber: '',
              expiryDate: '',
              productionDate: '',
            };
          }
          return item;
        });
        this.goodsSerialList = currentLists;
        this.$refs.xTable.loadData(currentLists);
        this.checkedLists = [];
        this.$refs.xTable.clearCheckboxRow();
        this.$set(this.dataList[this.currentIndex], 'warn', false);
        this.dataList[this.currentIndex].quantity = this.goodsSerialList.length;
        this.dataList[this.currentIndex].goodsSerialList = this.goodsSerialList;
        this.isShow = false;
      });
    },
    operate (type) {
      this.dockingSystem === 'XIAOZI_ERP' ? this.operateDeliveryGoods(type) : this.operateDeliveryGoods2(type);
    },
    async operateDeliveryGoods (type, index) {
      if (type === 'add') {
        if (this.goodsSerialList.length >= this.dataList[this.currentIndex].unDeliveredQuantity) {
          this.$message({
            message: `待发数量为${this.dataList[this.currentIndex].unDeliveredQuantity}，发货物资数量最大为${
              this.dataList[this.currentIndex].unDeliveredQuantity
            }`,
            type: 'warning',
          });

          return;
        }

        let item = _.cloneDeep(this.goodsSerialList[0]);

        item.productionDate = this.goodsSerialList[0].medicalFlag ? '' : this.setDate('produce');
        item.expiryDate = this.goodsSerialList[0].medicalFlag ? '' : this.setDate();

        if (this.goodsSerialList[0].medicalFlag) {
          item.productionBatchNumber = '';
          item.productionSerialNumber = '';
        }

        item.rowId = Math.random();

        if (item.id) {
          delete item.id;
        }

        this.goodsSerialList.push(item);
      } else if (type === 'reduce') {
        this.goodsSerialList.splice(index, 1);
      } else if (type === 'cancel') {
        this.visible = false;
      } else if (type === 'save') {
        const $table = this.$refs.xTable;
        let selectedRecords = $table.getCheckboxRecords();
        const errMap = await $table.validate(selectedRecords).catch((errMap) => errMap);
        if (!errMap) {
          this.$set(this.dataList[this.currentIndex], 'warn', false);

          this.dataList[this.currentIndex].quantity = this.goodsSerialList.length;
          this.dataList[this.currentIndex].goodsSerialList = this.goodsSerialList;
          this.visible = false;
        }
      }
    },
    async operateDeliveryGoods2 (type, index) {
      if (type === 'add') {
        if (this.goodsSerialList.length >= this.dataList[this.currentIndex].unDeliveredQuantity) {
          this.$message({
            message: `待发数量为${this.dataList[this.currentIndex].unDeliveredQuantity}，发货物资数量最大为${
              this.dataList[this.currentIndex].unDeliveredQuantity
            }`,
            type: 'warning',
          });
          return;
        }

        let item = _.cloneDeep(this.goodsSerialList[0]);

        item.productionDate = this.goodsSerialList[0].medicalFlag ? '' : this.setDate('produce');
        item.expiryDate = this.goodsSerialList[0].medicalFlag ? '' : this.setDate();

        if (this.goodsSerialList[0].medicalFlag) {
          item.batchNo = '';
          item.serialNo = '';
        }

        item.rowId = Math.random();

        this.goodsSerialList.push(item);
      } else if (type === 'reduce') {
        this.goodsSerialList.splice(index, 1);
      } else if (type === 'cancel') {
        this.visible = false;
      } else if (type === 'save') {
        const $table = this.$refs.xTable;
        let selectedRecords = $table.getCheckboxRecords();
        const errMap = await $table.validate(selectedRecords).catch((errMap) => errMap);
        if (!errMap) {
          this.$set(this.dataList[this.currentIndex], 'warn', false);

          this.dataList[this.currentIndex].quantity = this.goodsSerialList.length;
          this.dataList[this.currentIndex].goodsSerialList = this.goodsSerialList;
          this.visible = false;
        }
      }
    },
    handleFilterList () {
      this.dealMerge();
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }
      this.dealMerge();
    },
    handleCancelMerge (row) {
      this.$confirm(`是否确认取消合并收货信息为【${row.fullReceiverDetailAddress}】的所有订单？`, '取消合并', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.selectedKeys = [];
        this.selectedLists = [];
        this.dataList.map(item => {
          item.checked = false;
          if (row.codes.includes(item.code)) {
            item.merge = false;
            item.mergeSpan = 1;
          }
        });

        this.pageSelectedLists = [];
        const mergeCount = this.dataList.filter(item => item.merge && item.codes?.length).length;
        const notMergeCount = this.dataList.filter(item => !item.merge && item.rowSpan).length;
        this.pageSelectCount = mergeCount + notMergeCount;
      });
    },
    handleCancelShip (row) {
      const codes = row.merge ? row.codes || [] : [row.code];
      this.$confirm(`是否确认取消填单发货【${codes.join('、')}】订单？`, '取消填单发货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // 将dataList中取消发货的订单移除
        this.dataList = this.dataList.filter(item => !codes.includes(item.code)).map(item => {
          item.checked = false;
          return item;
        });
        this.pageSelectedLists = [];
        const mergeCount = this.dataList.filter(item => item.merge && item.codes?.length).length;
        const notMergeCount = this.dataList.filter(item => !item.merge && item.rowSpan).length;
        this.pageSelectCount = mergeCount + notMergeCount;

        // 将取消发货的订单从localSelectedAllLists中移除
        this.localSelectedAllLists = this.localSelectedAllLists.filter(item => !codes.includes(item.code));
        // 更新本地存储
        localStorage.setItem('selectedAllLists', JSON.stringify(this.localSelectedAllLists));
      });
    },
    handleDeliveryGoods (v, index) {
      this.dockingSystem = v.dockingSystem;
      this.isDirect = v.directFlag;
      if (this.dockingSystem === 'XIAOZI_ERP') {
        this.handleDeliveryGoods1(v, index);
      } else {
        this.handleDeliveryGoods2(v, index);
      }
    },
    handleDeliveryGoods1 (v, index) {
      this.childColumn = setDeliveryGoodsColumn.call(this, v.medicalFlag ? 1 : 2);
      this.currentIndex = index;
      let goodsSerialList = [];
      const goodsSerialLength = v.goodsSerialList && v.goodsSerialList.length ? v.goodsSerialList.length : 0;
      const num = goodsSerialLength ? goodsSerialLength : v.unDeliveredQuantity;
      for (let i = 0; i < num; i++) {
        let good = {
          goodsCode: v.outSkuCode,
          goodsName: v.goodsName,
          brandName: v.brandName,
          specsNo: v.specsNo || v.model,
          producer: v.manufacturer,
          deliveryNum: 1,
          isMedichair: v.medicalFlag ? 1 : 2,
          materialId: v.materialId,
          certificateNumber: v.certificateNumber,
          image: v.image,
        };

        // 获取暂存的填写内容
        let productionDate = '';
        let expiryDate = '';
        let productionBatchNumber = '';
        let productionSerialNumber = '';
        if (goodsSerialLength > 0 && i < goodsSerialLength) {
          productionDate = v.goodsSerialList[i].productionDate || '';
          expiryDate = v.goodsSerialList[i].expiryDate || '';
          productionBatchNumber = v.goodsSerialList[i].productionBatchNumber || '';
          productionSerialNumber = v.goodsSerialList[i].productionSerialNumber || '';
        }

        if (!v.medicalFlag) {
          good.productionDate = this.setDate('produce');
          good.expiryDate = this.setDate();
        } else {
          good.productionBatchNumber = productionBatchNumber;
          good.productionSerialNumber = productionSerialNumber;
        }

        if (productionDate && expiryDate) {
          good.productionDate = productionDate;
          good.expiryDate = expiryDate;
        }
        goodsSerialList.push(good);
      }
      this.goodsSerialList = _.cloneDeep(goodsSerialList);
      this.visible = true;
      // 初始化 批量操作信息
      let checkedChoices = ['productionDate', 'expiryDate', 'productionBatchNumber', 'productionSerialNumber'];
      let JZChoice = {
        productionBatchNumber: '',
        productionSerialNumber: '',
        expiryDate: '',
        productionDate: '',
      };
      this.isMedichair = v.medicalFlag;
      if (!this.isMedichair) {
        checkedChoices = ['productionDate', 'expiryDate'];
        JZChoice = {
          expiryDate: '',
          productionDate: '',
        };
      }
      this.checkedChoices = checkedChoices;
      this.JZChoice = JZChoice;
      this.checkedLists = [];
    },
    handleDeliveryGoods2 (v, index) {
      this.childColumn = setDeliveryGoodsColumn2.call(this);
      this.currentIndex = index;
      let goodsSerialList = [];
      const goodsSerialLength = v.goodsSerialList && v.goodsSerialList.length ? v.goodsSerialList.length : 0;
      const num = goodsSerialLength ? goodsSerialLength : v.unDeliveredQuantity;
      const orderGoodsSerial = v.orderGoodsSerialList?.length ? v.orderGoodsSerialList[0] : {};

      for (let i = 0; i < num; i++) {
        let goods = {
          ...v,
          quantity: 1,
        };

        if (orderGoodsSerial?.id) {
          goods.orderGoodsSerialId = orderGoodsSerial.id;
          goods.batchNo = orderGoodsSerial.batchNo;
          goods.serialNo = orderGoodsSerial.serialNo;
        }

        // 获取暂存的填写内容
        let productionDate = '';
        let expiryDate = '';
        if (goodsSerialLength > 0 && i < goodsSerialLength) {
          productionDate = v.goodsSerialList[i].productionDate || '';
          expiryDate = v.goodsSerialList[i].expiryDate || '';
        }

        if (!v.medicalFlag) {
          goods.productionDate = this.setDate('produce');
          goods.expiryDate = this.setDate();
        }

        if (productionDate && expiryDate) {
          goods.productionDate = productionDate;
          goods.expiryDate = expiryDate;
        }

        goodsSerialList.push(goods);
      }

      this.goodsSerialList = _.cloneDeep(goodsSerialList);
      this.visible = true;
      // 初始化 批量操作信息
      let checkedChoices = ['productionDate', 'expiryDate'];
      let JZChoice = {
        expiryDate: '',
        productionDate: '',
      };
      this.checkedChoices = checkedChoices;
      this.JZChoice = JZChoice;
      this.checkedLists = [];
    },
    handleEmpty2 () {
      this.JZChoice2 = {
        logisticsCompany: {},
        logisticsCode: '',
      };
    },
    handleEmpty () {
      let checkedChoices = this.checkedChoices;
      let JZChoice = this.JZChoice;
      checkedChoices.forEach((item) => {
        JZChoice[item] = '';
      });
      this.JZChoice = JZChoice;
    },
    handleEnsure2 () {
      // 将设置的物流信息和物流单号更新到选中的数据中
      this.dataList.forEach((item, index) => {
        if (this.selectedKeys.includes(item.id)) {
          if (this.checkedChoices2.logisticsCompany) {
            const logisticsCompany = this.JZChoice2.logisticsCompany?.id ? this.JZChoice2.logisticsCompany : {};
            this.$set(this.dataList[index], 'logisticsCompanyId', logisticsCompany?.id);
            this.$set(this.dataList[index], 'logisticsCompanyCode', logisticsCompany?.code);
            this.$set(this.dataList[index], 'logisticsCompanyName', logisticsCompany?.name);
          }
          if (this.checkedChoices2.logisticsCode) {
            this.$set(this.dataList[index], 'logisticsCode', this.JZChoice2.logisticsCode);
          }
        }
      });
      this.isShowBatch = !this.isShowBatch;
    },
    async handleEnsure () {
      if (!this.checkedChoices.length) {
        this.$JZShowAlert('请先选择要批次录入项', 'error');
        return;
      }

      let currentInfo = {};
      this.checkedChoices.map((item) => {
        currentInfo[item] = this.JZChoice[item];
      });

      this.$confirmAlert(`确认将选中项录入到选中的${this.checkedLists.length}条商品信息吗?`, '确认录入').then(() => {
        let currentLists = this.goodsSerialList.map((item, index) => {
          if (this.allSelectedIdLists.includes(index)) {
            item = {
              ...item,
              ...currentInfo,
            };
          }
          return item;
        });
        this.goodsSerialList = currentLists;
        this.$refs.xTable.loadData(currentLists);
        this.checkedLists = [];
        this.$refs.xTable.clearCheckboxRow();
        this.$set(this.dataList[this.currentIndex], 'warn', false);
        this.dataList[this.currentIndex].quantity = this.goodsSerialList.length;
        this.dataList[this.currentIndex].goodsSerialList = this.goodsSerialList;
        this.isShow = false;
      });
    },
    batchDelete () {
      // 将选中项中的数据从列表中移除
      // 将选中项数据数值初始化
      this.$confirmAlert(`确认将选中的${this.checkedLists.length}条数商品信息删除吗?`, '确认删除').then(() => {
        let currentLists
            = this.goodsSerialList.filter((item, index) => !this.allSelectedIdLists.includes(index)) || [];
        if (currentLists.length === 0) {
          this.$JZShowAlert('商品删除不可全部删除，至少需要有一条商品信息', 'warning');
          return;
        }
        this.goodsSerialList = currentLists;
        this.$refs.xTable.loadData(currentLists);
        this.checkedLists = [];
        this.$refs.xTable.clearCheckboxRow();
        this.$set(this.dataList[this.currentIndex], 'warn', false);
        this.dataList[this.currentIndex].quantity = this.goodsSerialList.length;
        this.dataList[this.currentIndex].goodsSerialList = this.goodsSerialList;
        this.isShow = false;
      });
    },
    handleChangeLogistics (val, row, index) {
      const logisticsCompany = this.logisticsOptions.find(item => item.id === val);
      this.$set(this.dataList[index], 'logisticsCompanyId', logisticsCompany?.id);
      this.$set(this.dataList[index], 'logisticsCompanyCode', logisticsCompany?.code);
      this.$set(this.dataList[index], 'logisticsCompanyName', logisticsCompany?.name);
    },
    logisticsList (query = '') {
      if (this.dockingSystem === 'XIAOZI_ERP') {
        this.logisticsList1(query);
      } else {
        this.logisticsList2(query);
      }
    },
    async logisticsList1 (query = '') {
      if (!query) return;
      const { body } = await getSupplierPage({
        status: 'EFFECTIVE',
        supplierType: 'CARRIER',
        supplierTypes: ['CARRIER'],
        pageSize: 10,
        nameOrNameEn: query,
        pageNum: 1,
      });
      this.logisticsOptions = body.list || [];
    },
    async logisticsList2 (query = '') {
      if (!query) return;
      const { body } = await logisticsCompany({
        name: query,
        pageFlag: true,
        pageNum: 1,
        pageSize: 10,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'ASC',
          },
        ],
      });
      this.logisticsOptions = body.list || [];
    },
    getList (type) {
      this.dataList = [];
      this.pageSelectCount = 0;
      this.pageSelectedLists = [];
      this.selectedKeys = [];
      this.selectedLists = [];
      let baseLists = [];
      if (type === 'init') {
        baseLists = this.localSelectedAllLists || [];
      } else {
        baseLists = this.filterLists || [];
      }

      if (this.merge) {
        this.getMergeList(baseLists);
      } else {
        this.getNormalList(baseLists);
      }

      this.pageSelectedLists = this.dataList.filter(item => item.checked);
    },
    getMergeList (baseLists) {
      // 1. 按 fullReceiverDetailAddress 排序
      const sortedData = [...baseLists].sort((a, b) => a.fullReceiverDetailAddress.localeCompare(b.fullReceiverDetailAddress));
      let list = [];
      // 2. 拆分成单独的项
      (sortedData || []).forEach(item => {
        (item.orderGoodsList || []).forEach((goods, index) => {
          if (!goods.medicalFlag) {
            goods.productionDate = this.setDate('produce');
            goods.expiryDate = this.setDate();
          } else {
            goods.productionDate = '';
            goods.expiryDate = '';
          }
          list.push({
            ...item,
            ...goods,
            id: `${item.id}-${index}`,
            orderGoodsId: goods.id || 0,
            orderId: item.id,
            merge: true,
            rowSpan: index === 0 ? item.orderGoodsList.length : null,
            checked: this.selectedKeys.includes(`${item.id}-${index}`),
          });
        });
      });
      // 3. 计算合并项
      this.dataList = this.processData(list);
    },
    processData (sortedData) {
      let addressList = [];
      this.pageSelectCount = 0;
      for (let i = 0; i < sortedData.length; i++) {
        let item = sortedData[i];
        if (!addressList.includes(item.fullReceiverDetailAddress)) {
          // 在sortedData中找到所有fullReceiverDetailAddress相同的项的index
          let indexList = sortedData.map((x, index) => x.fullReceiverDetailAddress === item.fullReceiverDetailAddress ? index : -1).filter(x => x !== -1);
          // 计算合并项的数量
          item.mergeSpan = indexList.length;
          item.ids = []; // 保存被合并的项的id，用于后续选中操作
          item.codes = []; // 保存被合并的项的code，用于后续选中操作
          indexList.forEach(index => {
            item.ids.indexOf(sortedData[index].id) === -1 && item.ids.push(sortedData[index].id);
            item.codes.indexOf(sortedData[index].code) === -1 && item.codes.push(sortedData[index].code);
          });
          this.pageSelectCount += 1;
          addressList.push(item.fullReceiverDetailAddress);
        }
      }
      return sortedData;
    },
    getNormalList (baseLists) {
      (baseLists || []).forEach(item => {
        (item.orderGoodsList || []).forEach((goods, index) => {
          if (!goods.medicalFlag) {
            goods.productionDate = this.setDate('produce');
            goods.expiryDate = this.setDate();
          } else {
            goods.productionDate = '';
            goods.expiryDate = '';
          }
          const goodsItem = {
            ...item,
            ...goods,
            id: `${item.id}-${index}`,
            orderGoodsId: goods.id || 0,
            orderId: item.id,
            rowSpan: index === 0 ? item.orderGoodsList.length : null,
            checked: this.selectedKeys.includes(`${item.id}-${index}`),
          };
          if (index === 0) {
            goodsItem.orderGoodsIds = item.orderGoodsList.map(goods => goods.id);
          }
          this.dataList.push(goodsItem);

          // 统计未合并且未发货的订单数
          if (index === 0) {
            this.pageSelectCount += 1;
          }
        });
      });
    },
    cancel () {
      this.finish();
    },
    // 校验方法
    checkSubmit () {
      // 校验必填项【发货数量、物流公司、物流单号、生产日期、失效日期】，医疗件【生产批次号、生产序列号】
      let isError = [];
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];

        // 合并
        if (item.merge && item.codes?.length > 0) {
          // 校验必填项【物流公司、物流单号】
          if (!item.logisticsCompanyId || !item.logisticsCompanyCode || !item.logisticsCompanyName || !item.logisticsCode) {
            if (!isError.includes('存在未填写物流单号订单，请补充')) {
              isError.push('存在未填写物流单号订单，请补充');
            }
          }
        } else if (!item.merge && item.rowSpan > 0) { // 未合并
          if (!item.logisticsCompanyId || !item.logisticsCompanyCode || !item.logisticsCompanyName || !item.logisticsCode) {
            if (!isError.includes('存在未填写物流单号订单，请补充')) {
              isError.push('存在未填写物流单号订单，请补充');
            }
          }
        }
        // 校验【发货数量】
        if (!item.quantity) {
          if (!isError.includes('存在未填写发货数量订单，请补充')) {
            isError.push('存在未填写发货数量订单，请补充');
          }
        }

        // 校验必填项【生产日期、失效日期】，医疗件【生产批次号、生产序列号】
        // 直发订单
        if (item.dockingSystem === 'XIAOZI_ERP') {
          if (item.directFlag === 1) {
            let hasError = false;
            if (item.medicalFlag) {
              hasError = !item.goodsSerialList || (item.goodsSerialList || []).find(goods => !goods.productionDate || !goods.expiryDate);
              if (hasError) {
                this.$set(item, 'warnMsg', '请完善发货商品信息');
                this.$set(item, 'warn', true);
                if (!isError.includes('存在医疗件未填写生产日期或失效日期订单，请补充')) {
                  isError.push('存在医疗件未填写生产日期或失效日期订单，请补充');
                }
              }
              hasError = !item.goodsSerialList || (item.goodsSerialList || []).find(goods => !goods.productionBatchNumber && !goods.productionSerialNumber);
              if (hasError) {
                this.$set(item, 'warnMsg', '请完善发货商品信息');
                this.$set(item, 'warn', true);
                if (!isError.includes('存在医疗件商品未填写生产批次号或生产序列号，请补充')) {
                  isError.push('存在医疗件商品未填写生产批次号或生产序列号，请补充');
                }
              }
            } else {
              // 手动删除了默认日期
              hasError = item.goodsSerialList?.length > 0 && (item.goodsSerialList || []).find(goods => !goods.productionDate || !goods.expiryDate);
              if (hasError) {
                this.$set(item, 'warnMsg', '请完善发货商品信息');
                this.$set(item, 'warn', true);
                if (!isError.includes('存在未填写生产日期或失效日期订单，请补充')) {
                  isError.push('存在未填写生产日期或失效日期订单，请补充');
                }
              }
            }
          }
        }
        if (item.dockingSystem !== 'XIAOZI_ERP' && item.medicalFlag) {
          const hasError = !item.goodsSerialList || (item.goodsSerialList || []).find(goods => !goods.productionDate || !goods.expiryDate);
          if (hasError) {
            this.$set(item, 'warnMsg', '请完善发货商品信息');
            this.$set(item, 'warn', true);
            if (!isError.includes('存在未填写生产日期或失效日期订单，请补充')) {
              isError.push('存在未填写生产日期或失效日期订单，请补充');
            }
          }
        }
      }

      if (isError?.length) {
        const messageHtml = isError.map(item => `<div>${item}</div>`).join('<br>');
        this.$message({
          dangerouslyUseHTMLString: true,
          message: messageHtml,
          type: 'warning',
          duration: 5000,
        });
        return false;
      }
      return true;
    },
    submit () {
      // console.log('确认发货', this.dataList);
      // 校验
      if (!this.checkSubmit()) {
        return;
      }

      // 提交
      let deliveryList = [];
      let orderIds = [];
      this.dataList.forEach((item, index) => {
        if (!orderIds.includes(item.orderId)) { // 只遍历主展示行，同个订单只遍历一次
          let logisticsGoodsList = [];
          let deliveryGoodsList = [];
          let logistics = [];
          let currentOrderGoods = []; // 订单下所有商品行
          // 合并的
          if (item.merge && item.codes?.length > 0) {
            const mergeSpan = item.mergeSpan;
            for (let i = index; i < index + mergeSpan; i++) {
              this.dataList[i].logisticsCode = item.logisticsCode;
              this.dataList[i].logisticsCompanyId = item.logisticsCompanyId;
              this.dataList[i].logisticsCompanyCode = item.logisticsCompanyCode;
              this.dataList[i].logisticsCompanyName = item.logisticsCompanyName;
            }
          }

          if (item.rowSpan > 0) { // 主展示行
            // 发货商品
            const rowSpan = item.rowSpan;
            for (let i = index; i < index + rowSpan; i++) {
              currentOrderGoods.push(this.dataList[i]);
            }
          }

          currentOrderGoods.map(v => {
            // 物流
            logisticsGoodsList.push({
              orderGoodsId: v.orderGoodsId || '',
              quantity: v.quantity,
            });

            // 发货商品
            if (v.dockingSystem === 'XIAOZI_ERP') {
              if (v.directFlag === 1) { // 直发订单
                let deliveryGoodsSerialList = [];
                if (v.medicalFlag) {
                  (v.goodsSerialList || []).map(goods => {
                    deliveryGoodsSerialList.push({
                      quantity: 1,
                      // orderGoodsSerialId: v.orderGoodsSerialId || '',
                      productionDate: goods.productionDate ? new Date(goods.productionDate).getTime() : '',
                      expiryDate: goods.expiryDate ? new Date(goods.expiryDate).getTime() : '',
                      batchNo: goods.productionBatchNumber || '',
                      serialNo: goods.productionSerialNumber || '',
                    });
                  });
                } else {
                  if (!v.goodsSerialList || v.goodsSerialList.length === 0) {
                    // 未手动填写发货商品
                    for (let j = 0; j < v.quantity; j++) {
                      deliveryGoodsSerialList.push({
                        quantity: 1,
                        // orderGoodsSerialId: v.orderGoodsSerialId || '',
                        productionDate: v.productionDate ? new Date(v.productionDate).getTime() : '',
                        expiryDate: v.expiryDate ? new Date(v.expiryDate).getTime() : '',
                      });
                    }
                  } else {
                    // 手动填写发货商品
                    (v.goodsSerialList || []).map(goods => {
                      deliveryGoodsSerialList.push({
                        quantity: 1,
                        // orderGoodsSerialId: v.orderGoodsSerialId || '',
                        productionDate: goods.productionDate ? new Date(goods.productionDate).getTime() : '',
                        expiryDate: goods.expiryDate ? new Date(goods.expiryDate).getTime() : '',
                      });
                    });
                  }
                }
                deliveryGoodsList.push({
                  orderGoodsId: v.orderGoodsId || '',
                  quantity: v.quantity,
                  deliveryGoodsSerialList: deliveryGoodsSerialList,
                });
              } else { // 非直发订单
                deliveryGoodsList.push({
                  orderGoodsId: v.orderGoodsId || '',
                  quantity: v.quantity,
                });
              }
            }
            if (v.dockingSystem !== 'XIAOZI_ERP') {
              let deliveryGoodsSerialList = [];
              if (!v.goodsSerialList || v.goodsSerialList.length === 0) {
                // 未手动填写发货商品
                const orderGoodsSerial = v.orderGoodsSerialList?.length ? v.orderGoodsSerialList[0] : {};
                for (let j = 0; j < v.quantity; j++) {
                  deliveryGoodsSerialList.push({
                    quantity: 1,
                    orderGoodsSerialId: orderGoodsSerial.id || '',
                    productionDate: v.productionDate ? new Date(v.productionDate).getTime() : '',
                    expiryDate: v.expiryDate ? new Date(v.expiryDate).getTime() : '',
                    batchNo: orderGoodsSerial.batchNo || '',
                    serialNo: orderGoodsSerial.serialNo || '',
                  });
                }
              } else {
                // 手动填写发货商品
                (v.goodsSerialList || []).map(goods => {
                  deliveryGoodsSerialList.push({
                    quantity: 1,
                    orderGoodsSerialId: goods.orderGoodsSerialId || '',
                    productionDate: goods.productionDate ? new Date(goods.productionDate).getTime() : '',
                    expiryDate: goods.expiryDate ? new Date(goods.expiryDate).getTime() : '',
                    batchNo: goods.batchNo || '',
                    serialNo: goods.serialNo || '',
                  });
                });
              }
              deliveryGoodsList.push({
                orderGoodsId: v.orderGoodsId || '',
                quantity: v.quantity,
                deliveryGoodsSerialList: deliveryGoodsSerialList,
              });
            }
          });

          logistics = {
            code: item.logisticsCode,
            logisticsCompanyId: item.logisticsCompanyId,
            logisticsCompanyCode: item.logisticsCompanyCode,
            logisticsCompanyName: item.logisticsCompanyName,
            logisticsGoodsList: logisticsGoodsList,
          };

          deliveryList.push({
            orderId: item.orderId,
            orderCode: item.code,
            deliveryGoodsList: deliveryGoodsList,
            logistics: logistics,
          });
        }
        orderIds.push(item.orderId);
      });

      // console.log('提交接口：', deliveryList);

      batchAdd({
        deliveryList: deliveryList,
      }).then(({body}) => {
        const successOrder = (body.itemList || []).filter(item => item.status === 1).map(item => item.orderCode).join(',');
        const failOrder = (body.itemList || []).filter(item => item.status === 2).map(item => `${item.orderCode}：${item.failMessage}`).join(',');

        const successTip = successOrder ? `发货成功：【${successOrder}】` : '';
        const failTip = failOrder ? `发货失败：【${failOrder}】` : '';

        if (!failOrder) {
          this.$message.success('发货完成，稍后请刷新页面查看最新发货状态');
          setTimeout(() => {
            this.finish();
          }, 1000);
        } else {
          this.$confirm(`${successTip}${failTip}`, '提示', {
            cancelButtonText: '关闭',
            showConfirmButton: false,
            type: 'warning',
          }).then(() => {
            this.finish();
          }).catch(() => {
            this.finish();
          });
        }
      });
    },
    finish () {
      localStorage.removeItem('selectedAllKeys');
      localStorage.removeItem('selectedAllLists');
      localStorage.setItem('refresh', true);
      this.$router.back();
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .c_group {
      position: relative;

      .content_block {
        border-bottom: 0.5px solid #DFE2E8;
        padding: 10px;
      }

      .title {
        font-size: 14px;
        font-weight: 600;
        padding-right: 2em;
      }
    }

    .right-box {
      display: inline-flex;
      align-items: center;
    }

    .table-wrapper {
      padding: 16px 12px;
      flex: 1;
      overflow: auto;
      background: #fff;

      .ant-radio-button-wrapper {
        border-width: 0;
        background-color: #f2f4f7;

        &.active-radio {
          border-color: #e2f3fe;
          background-color: #e2f3fe;
          color: #237ffa;
        }
      }

      .ant-radio-button-wrapper:not(:first-child)::before {
        width: 0;
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}

/deep/ .contract-option {
  color: #02a7f0;
  cursor: pointer;
  padding: 0 0.25em;
}

/deep/ .popper__arrow {
  display: none;
}

/deep/ .num {
  color: blue;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

/deep/ .warn {
  color: red;
  font-size: 12px;
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
